import styled from 'styled-components'
import theme from '../../../common/theme'

export const Wrapper = styled.div`
  margin-top: 197px;
  padding-bottom: 530px;
  text-align: center;
  font-family: 'Raleway';
  @media (max-width: 576px) {
    padding-bottom: 330px;
  }
`

export const NameAndPosition = styled.p`
  color: ${theme.color.blue};
  font-size: 28px;
  margin-top: 43px;
  @media (max-width: 768px) {
    font-size: 25px;
  }
  @media (max-width: 576px) {
    font-size: 22px;
  }
`

export const Card = styled.div`
  height: 390px;
  width: 572px;
  padding: 90px 118px 66px 118px;
  text-align: center;
  background: ${theme.color.white};
  color: #6e6a6a;
  box-shadow: 5px 12px 20px #003a56;
  font-size: 21px;
  border-radius: 10px;
  box-sizing: border-box;

  @media (max-width: 992px) {
    height: 390px;
    width: 420px;
    padding: 90px 16px 32px 16px;
  }
  @media (max-width: 768px) {
    height: 390px;
    width: 320px;
    padding: 90px 16px 32px 16px;
    font-size: 18px;
  }
  @media (max-width: 576px) {
    height: 390px;
    width: 184px;
    padding: 64px 16px 32px 16px;
    font-size: 15px !important;
  }
`

export const CardsContainer = styled.div`
  margin-top: 320px;
  position: relative;
  width: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: middle;
`
